import { ArrowLeft, Loader2 } from "lucide-react";
import { Link, useParams } from "react-router";

import { APIError } from "@/adapters/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useWorksite } from "@/features/canteiros/hooks/use-worksite.ts";
import { RdoEditor } from "@/features/rdo/components/rdo-editor";
import { useRdo } from "@/features/rdo/hooks/use-rdo.ts";
import { useActiveObra } from "@/features/stages/hooks/use-active-obra.ts";
import { usePermissions } from "@/hooks/use-permissions.ts";

export function RdoEditorPage() {
	const { obra: obraKey = "", rdoId } = useParams();
	const { has, isLoading: permsLoading } = usePermissions();
	const {
		obra,
		isLoading: obraLoading,
		isError: obraError,
		refetch: refetchObra,
	} = useActiveObra();
	const worksiteQuery = useWorksite(obra?.canteiroId);
	const rdoQuery = useRdo(obra?.id, rdoId);

	const backLink = (
		<Button asChild variant="ghost" size="sm" className="rdo-editor-page__back">
			<Link to={`/${obraKey}/rdo`}>
				<ArrowLeft /> Voltar para a lista
			</Link>
		</Button>
	);

	function body() {
		if (obraError) {
			return (
				<Card>
					<CardContent className="card-state">
						<p>Não foi possível carregar a obra.</p>
						<Button variant="outline" onClick={() => refetchObra()}>
							Tentar novamente
						</Button>
					</CardContent>
				</Card>
			);
		}
		if (permsLoading || obraLoading || !obra || rdoQuery.isPending) {
			return (
				<div className="page-loading">
					<Loader2 />
				</div>
			);
		}
		if (rdoQuery.isError) {
			const notFound =
				rdoQuery.error instanceof APIError &&
				rdoQuery.error.code === "not-found";
			return (
				<Card>
					<CardContent className="card-state">
						<p>
							{notFound
								? "Relatório de Obra não encontrado."
								: "Não foi possível carregar o Relatório de Obra."}
						</p>
						{!notFound && (
							<Button variant="outline" onClick={() => rdoQuery.refetch()}>
								Tentar novamente
							</Button>
						)}
					</CardContent>
				</Card>
			);
		}
		return (
			<RdoEditor
				key={rdoQuery.data.id}
				rdo={rdoQuery.data}
				constructionId={obra.id}
				obraKey={obraKey}
				obraName={obra.name}
				canteiroName={worksiteQuery.data?.name}
				canUpdate={has("rdos:update")}
				canFinalize={has("rdos:finalize")}
				canDelete={has("rdos:delete")}
			/>
		);
	}

	return (
		<div className="rdo-editor-page">
			{backLink}
			{body()}
		</div>
	);
}
